<template>
  <div v-if="project[activeBox]">
    <div class="rounded-2xl p-4 mt-2" :style="{ 'background-color': project[activeBox].color }">
      <div id="boxHeader" class="grid grid-cols-2 items-center">
        <h2 class="uppercase text-center align-middle text-lg">Casier n°{{ parseInt(activeBox) + 1 }}</h2>
        <GenericButton v-if="project.length > 1" :text="'SUPPRIMER'" :icon="'minus'" @click="$emit('removeActiveBox')" />
      </div>
      <!-- TO DO FREE SPACES -->
      <!-- <div id="boxParameters">
        <p class="subText">Type</p>
        <div id="boxTypes">
          <p :class="project[activeBox].isBox ? 'selected' : ''" @click="$emit('changeType', true)">Casier</p>
          <p :class="!project[activeBox].isBox ? 'selected' : ''" @click="$emit('changeType', false)">Taille Libre</p>
        </div>
      </div> -->
      <template v-if="project[activeBox].isBox">
        <div class="flex flex-row items-center gap-4 mb-4 mt-2">
          <p class="subText">Largeur (cm) :</p>
          <!-- Width -->
          <template v-for="width of data.box.width" :key="width">
            <ToggleButton
              :text="width.toString()"
              :class="[width === project[activeBox].box.width ? 'filled' : '', 'smallest']"
              @click="$emit('updateBox', 'width', width)"
            />
          </template>
        </div>
        <div class="flex flex-row items-center gap-4">
          <p class="subText">Hauteur (cm) :</p>
          <!-- Height -->
          <template v-for="height of data.box.height" :key="height">
            <ToggleButton
              :text="height.toString()"
              :class="[height === project[activeBox].box.height ? 'filled' : '', 'smallest']"
              @click="$emit('updateBox', 'height', height)"
            />
          </template>
        </div>
      </template>

      <h2 class="uppercase text-center text-base mt-2">Contenu du casier</h2>
      <div v-if="project[activeBox].content.length === 0 && addPending === false" class="normal-case text-sm text-center">
        <p>Aucun élément additionnel n'a été ajouté pour le moment.</p>
        <p>Pour ce faire, veuillez appuyer sur le bouton ci-dessous :</p>
      </div>
      <!-- Accessory -->
      <div v-for="element of project[activeBox].content" :key="element.id" class="flex flex-row gap-4 items-center justify-between mb-2 text-sm">
        <p class="uppercase">{{ translations[element.name] }}</p>
        <div id="accessory-custom" class="grid gap-2 items-center justify-items-center lg:justify-items-start">
          <p class="col-start-1 col-end-3 lg:col-start-1 lg:col-end-2 text-center lg:text-right">Hauteur :</p>
          <input
            class="col-start-1 col-end-2 lg:col-start-2 lg:col-end-3 border-2 rounded border-accent text-center lg:text-right"
            type="number"
            step="1"
            :value="element.height"
            @input="$emit('setContentHeight', element.id, $event.target.value)"
          />
          <p class="col-start-2 col-end-3 lg:col-start-3 lg:col-end-4">cm</p>
          <GenericButton
            :text="'SUPPRIMER'"
            :icon="'minus'"
            @click="$emit('removeAccessory', element.id)"
            class="col-start-1 col-end-3 lg:col-start-4 lg:col-end-5"
          />
        </div>
      </div>
      <!-- Add -->
      <div v-if="addPending === true" class="normal-case text-sm text-center">
        <p>Choisir un élément à ajouter :</p>
      </div>
      <div class="mt-2 flex flex-row items-center justify-center">
        <GenericButton v-if="addPending === false" :text="'Nouvel accessoire'" :icon="'plus'" @click="addClicked" />
        <div v-else class="flex flex-row items-center gap-4">
          <GenericButton v-for="(item, key) in data.accesories" :key="key" :text="translations[key]" :hideIcon="true" @click="accesorySelected(key)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenericButton from '@/components/ui/GenericButton.vue';
import ToggleButton from '@/components/ui/ToggleButton.vue';

export default {
  name: 'BoxConfig',
  components: {
    GenericButton,
    ToggleButton,
  },
  props: {
    project: Object,
    activeBox: Number,
  },
  data() {
    return {
      data: require('../../data.json'),
      addPending: false,
      translations: {
        tablet: 'Tablette',
        drawer: 'Tiroir',
        pandering: 'Penderie',
      },
    };
  },
  methods: {
    addClicked() {
      if (this.project[this.activeBox].isBox) {
        this.addPending = true;
      } else {
        this.$emit('newContent', 'panel');
      }
    },
    accesorySelected(key) {
      this.$emit('newContent', key);
      this.addPending = false;
    },
  },
};
</script>

<style scoped>
input {
  width: 60px;
}

#boxHeader {
  grid-template-columns: 1fr auto;
}

#accessory-custom {
  grid-template-rows: repeat(3, auto);
  grid-template-columns: auto min-content;
}

@media (min-width: 1024px) {
  #accessory-custom {
    grid-template-rows: auto;
    grid-template-columns: auto auto auto max-content;
  }
}
</style>
